import React, { useContext, useMemo } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { GlobalContext, globalOnDemandVars } from '../../../helper/context'
import { Tooltip } from '@blueprintjs/core'
import { OverlayProps } from '../../../helper/configs'
import { InsertFormArray } from '../../addon/addons/parts/forEachInsertForm/insertFormRegister'
import { hasScrollbarAlways } from '../../../helper/CSSclasses'
import ThumbNail from '../../addon/addons/parts/forEachInsertForm/thumbnail'
import LoadingCover from '../../commonInterface/loadingCover'
import { exampleMediaItems } from '../../../helper/variables'

function MediaBlock ({ src: id, alt: type }) {
  const context = useContext(GlobalContext)

  const content = useMemo(() => {
    let item
    const maybeItem = context.uploadType2Ready ? globalOnDemandVars.uploadType2s()[id] : null
    if (maybeItem) {
      item = maybeItem
    } else {
      const id2 = type + id
      if (type === 'Example') {
        item = exampleMediaItems.find((maybeItem) => (String(maybeItem.id) === String(id2)))
      } else {
        item = context.type1Ready ? globalOnDemandVars.type1Items().find((maybeItem) => (String(maybeItem.id) === String(id2))) : null
      }
    }
    // console.tron.display({
    //   name: 'MediaBlock',
    //   preview: `${id}, ${type}`,
    //   value: {
    //     id,
    //     type,
    //     item,
    //     type1Items: globalOnDemandVars.type1Items()
    //   }
    //   // , important: true
    // })

    let returnValue
    if (item) {
      // if (item.type === 'dummyType') {
      //   return (<div>
      //     <div css={css`border: dashed 2px purple;`}>{`${item.type} - ${item.content}`}</div>
      //   </div>)
      // }
      const ClassForType = InsertFormArray.find((oneClass) => (oneClass.type === item.type))
      if (ClassForType) {
        returnValue = (<ThumbNail item={item} displayEdit displayPreview />
        )
      } else {
        const string = 'Wrong Type'
        returnValue = (
          <Tooltip content={string} {...OverlayProps}>
            <span css={css`background-color: var(--gray3);`}>(Media Error)</span>
          </Tooltip>)
      }
    } else {
      const string = 'Wrong Id'
      returnValue = (
        <Tooltip content={string} {...OverlayProps}>
          <span css={css`background-color: var(--gray3);`}>(Media Error)</span>
        </Tooltip>)
    }

    return returnValue
  }, [context.type1Ready, context.uploadType2Ready, id, type])

  return (
    useMemo(() => (<div css={css`display: inline;`}>
      {(context.type1Ready && context.uploadType2Ready) ? null : <LoadingCover />}
      {content}
    </div>), [content, context.type1Ready, context.uploadType2Ready])
  )
}

export function MediaBlockWithoutThumbnail ({ src: id, alt: type }) {
  const context = useContext(GlobalContext)

  const content = useMemo(() => {
    let item
    const maybeItem = context.uploadType2Ready ? globalOnDemandVars.uploadType2s()[id] : null
    if (maybeItem) {
      item = maybeItem
    } else {
      const id2 = type + id
      item = context.type1Ready ? globalOnDemandVars.type1Items().find((maybeItem) => (String(maybeItem.id) === String(id2))) : null
    }
    // console.tron.display({
    //   name: 'MediaBlock',
    //   preview: `${id}, ${type}`,
    //   value: {
    //     id,
    //     type,
    //     item,
    //     type1Items: globalOnDemandVars.type1Items()
    //   }
    //   // , important: true
    // })

    let returnValue
    if (item) {
      if (item.type === 'dummyType') {
        return (<div>
          <div css={css`border: dashed 2px purple;`}>{`${item.type} - ${item.content}`}</div>
        </div>)
      }
      const ClassForType = InsertFormArray.find((oneClass) => (oneClass.type === item.type))
      if (ClassForType) {
        returnValue = (<div css={css`max-width: 98%; max-height: 500px; overflow: auto;`} className={hasScrollbarAlways}><ClassForType.Render contentData={item.content} replacedForThumbnail /></div>)
      } else {
        const string = 'Wrong Type'
        returnValue = (
          <Tooltip content={string} {...OverlayProps}>
            <span css={css`background-color: var(--gray3);`}>(Media Error)</span>
          </Tooltip>)
      }
    } else {
      const string = 'Wrong Id'
      returnValue = (
        <Tooltip content={string} {...OverlayProps}>
          <span css={css`background-color: var(--gray3);`}>(Media Error)</span>
        </Tooltip>)
    }

    return returnValue
  }, [context.type1Ready, context.uploadType2Ready, id, type])

  return (
    useMemo(() => (<div css={css`display: inline;`}>
      {(context.type1Ready && context.uploadType2Ready) ? null : <LoadingCover />}
      {content}
    </div>), [content, context.type1Ready, context.uploadType2Ready])
  )
}

export default MediaBlock
